module.exports = __webpack_public_path__ + "img/visual_img.9ea950f2.png";